import type {
  ApiMarketplaceAccessDenialListResponse,
  FetchMarketplaceAccessDenialsArgs,
  RestoreMarketplaceAccessArgs,
  DenyMarketplaceAccessArgs,
} from './types/marketplaceAccess.types';

import { post, get } from './axios';

const ADMIN_MARKETPLACE_PATH = '/v2/admin/marketplace';

export const fetchMarketplaceAccessDenials = async ({
  activeOnly,
  limit,
  offset,
}: FetchMarketplaceAccessDenialsArgs) => {
  const response = await get<ApiMarketplaceAccessDenialListResponse>(
    `${ADMIN_MARKETPLACE_PATH}/access-denials`,
    {
      query: {
        activeOnly: String(activeOnly),
        limit: String(limit),
        offset: String(offset),
      },
    },
  );
  return response ?? { data: [], limit, offset, total: 0 };
};

export const denyMarketplaceAccess = async ({
  marketplaceId,
  reason,
}: DenyMarketplaceAccessArgs) => {
  await post(`${ADMIN_MARKETPLACE_PATH}/items/${marketplaceId}/deny-access`, {
    reason,
  });
};

export const restoreMarketplaceAccess = async ({
  denialId,
}: RestoreMarketplaceAccessArgs) => {
  await post(
    `${ADMIN_MARKETPLACE_PATH}/access-denials/${denialId}/restore`,
    {},
  );
};
